


import Vue from 'vue'
import VueBus from 'vue-bus'
import App from './App'
import router from './router'
import store from './vuex/store'
import devVar from './dev-variable/dev-variable.js'
import _ from 'lodash'
import appNewRouter from './router/appNewRouterData.js'
import RouterConfig from './router/router.config'
import ts from './ts-loader-work.ts'
import '@/assets/style/vant/lib/index.less'






import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'



import utils from './tools/utils'
import http from './tools/http'
import api from './tools/api'
import dsBridge from 'dsbridge'

Vue.component('x-header', XHeader)
Vue.component('loading', Loading)
Vue.component('x-input', XInput)
Vue.component('group', Group)
Vue.component('x-button', XButton)
Vue.component('alert', Alert)
Vue.component('toast', Toast)
Vue.component('inlineLoading', InlineLoading)

Vue.prototype.utils = utils
Vue.prototype.http = http
Vue.prototype.api = api
Vue.prototype.router = router
Vue.prototype.devVar = devVar
Vue.prototype.localDev = window.location.hostname === 'zhihui-more'


Vue.use(_)


Vue.use(VueBus)

Vue.config.productionTip = false






const isNingXiangApp = window.location.href.indexOf('ningxiang-apps') > -1

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: {
App
},
template: '<App/>',
data() {
return {
requestCode: ''
}
},
created() {
this.$store.commit('setTitle', '登录验证')
this.$store.commit('setLeftOptions', {
showBack: false,
backText: ''
})
},
mounted() {
isNingXiangApp && this.getRequestCode()
},
computed: {
getProductName() {
return this.$store.state.productName
}
},
watch: {
getProductName(val) {
if (val && val.length > 0) {
if (!isNingXiangApp) this.login()
}
}
},
methods: {
async getRequestCode() {
const {
data: { initCode }
} = await this.http.get('/moreapi/user/init-code')

sc.config({
debug: false, // 开发时建议把调试模式开启
appId: 'c0ba696c52dc444e861daf88582e04d5', // 从开放平台申请到的appId
initCode: initCode 
})


const _this = this
sc.ready(function() {
sc.userAuth({ userDataTypes: ['001'] }, function(res) {
if (res.code === 0) {
const requestCode = res.data.requestCode
_this.requestCode = requestCode
_this.nxLogin(requestCode)
}
})
})
},
nxLogin(requestCode) {
if (this.$route.query && this.$route.query.tabIndex) {
sessionStorage.setItem('tabIndex', this.$route.query.tabIndex)
}

const postData = {
org_flag: this.$route.query.org_flag || 'ningxiangshi',
product_flag: this.$route.query.product_flag || 'Todo',
request_code: requestCode,
response_type: 'ningxiang-apps'
}

this.http.post('/moreapi/user/nx-login', postData).then(loginRes => {

if (loginRes.success === 'Success') {
const RES = loginRes.data

sessionStorage.setItem('productName', RES.product_code)
sessionStorage.setItem('rootId', RES.root_id)

store.commit('setProductName', RES.product_code)

if (Vue.prototype.$debug) {

console.log('rootId----->', RES.root_id)

console.log('ProductCode----->', RES.product_code)
}

this.otherLogin(RES.g_person_id, RES.name, RES.product_code)
}
})
},
login() {
let me = this
let flag = true

dsBridge.call('getBaseInfo', function(res) {
let RES = JSON.parse(res)

if (RES || process.env.NODE_ENV === 'development') {
flag = false


if (RES.debug) {
Vue.prototype.$debug = RES.debug
let VConsole = require('vconsole')
const vConsole = new VConsole()
}
sessionStorage.setItem('productName', RES.product_code)
sessionStorage.setItem('rootId', RES.root_id)

if (Vue.prototype.$debug) {

console.log('rootId----->', RES.root_id)

console.log('ProductCode----->', RES.product_code)
}


if (me.devVar.authConfig.map(val => val.productCode).includes(RES.product_code)) {
me.otherLogin(RES.g_person_id, RES.name, RES.product_code)
} else {
me.getRouters() 
}
} else {
store.commit('setGlobalAlertStatus', true)
store.commit('setGlobalAlertText', '无权限，您无法使用此功能！')
}
})


setTimeout(() => {
if (flag && (process.env.NODE_ENV === 'development' || me.localDev)) {
sessionStorage.setItem('productName', me.devVar.users.product_code)
sessionStorage.setItem('rootId', me.devVar.users.rootId)

if (
me.devVar.authConfig.map(val => val.productCode).includes(me.devVar.users.product_code)
) {
me.otherLogin(
me.devVar.users.g_person_id,
me.devVar.users.name,
me.devVar.users.product_code
)
} else {
me.getRouters() 
}
}
}, 1000)
},
async getRouters(role) {
console.log('getRouters-----', 'role -> ', role)

let productName = sessionStorage.getItem('productName')
const oldRouterAppProduct = ['address', 'CheckIn', 'JW_system']
let routerData
if (oldRouterAppProduct.includes(productName)) {
routerData = await Vue.prototype.http.get(
'/static/config/' + productName + '/permission-' + productName + '.json',
'',
'noApi'
)
Vue.prototype.router.addRoutes(Vue.prototype.utils.dynamicRouter(routerData))
} else {

const filterMenu = appNewRouter => {
return appNewRouter
.filter(item => {
if (!item.meta || !item.meta.auth) return false
const listData = item.meta.auth.listData
const listType = item.meta.auth.listType
if (listData.hasOwnProperty(productName)) {
const checked = listData[productName].some(element => {
return element.toLowerCase() === role.toLowerCase()
})
if (listType === 'white') return checked
if (listType === 'black') return !checked
} else {
return false
}
})
.map(item => {
item = Object.assign({}, item)
if (item.children) {
item.children = filterMenu(item.children)
}
return item
})
}
routerData = filterMenu(appNewRouter)

console.log('routerData --->', routerData)
Vue.prototype.router.addRoutes(routerData)
}

console.log('Vue.prototype.router --> ', Vue.prototype.router)

sessionStorage.setItem('router', JSON.stringify(routerData))
Vue.prototype.router.addRoutes([{ path: '*', component: RouterConfig['404'] }])
this.$router.push('/')

console.log('push in /')
},

async otherLogin(gPersonId, name, productCode) {
let me = this
let authConfig = devVar.authConfig.filter(val => val.productCode === productCode)[0]

console.log('authConfig---->', authConfig)

me.utils.removeLocalStorage(productCode)

let postData = authConfig.postData(gPersonId, name, productCode)
let title = authConfig.title
if (title) document.title = title
let url =
process.env.NODE_ENV === 'development' || me.localDev
? authConfig.authDevPath()
: authConfig.authPath()
let loginRes = await me.http.post(url, postData)
if (loginRes.success === 'Success') {

const role = authConfig.getRole(loginRes.data)
const userInfo = authConfig.getLoginResData(loginRes.data)
me.utils.setLocalStorage(productCode, userInfo)
me.$store.commit('setRole', role)
me.$store.commit('setUserInfo', userInfo)
console.log('getRouters')
me.getRouters(role)
me.loading = false
console.log('remove loading')
} else {
me.hasRole = true
}
}
}
})



// WEBPACK FOOTER //
// ./src/main.js